import React, { ChangeEvent } from "react";
import { Transaction, SortConfig } from "../types";

interface TransactionsTableProps {
  filteredTransactions: Transaction[];
  handleSort: (key: string) => void;
  page: number;
  total: number;
  limit: number;
  handlePrev: () => void;
  handleNext: () => void;
  handleLimitChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  sortConfig: SortConfig;
}

const TransactionsTable: React.FC<TransactionsTableProps> = ({
  filteredTransactions,
  handleSort,
  page,
  total,
  limit,
  handlePrev,
  handleNext,
  handleLimitChange,
  sortConfig,
}) => (
  <div className="w-full max-w-4xl mx-auto bg-white dark:bg-gray-900 shadow rounded p-2 mb-3">
    <h2 className="text-lg font-semibold mb-1 text-gray-800 dark:text-gray-100">Transactions</h2>
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto text-sm">
        <thead>
          <tr className="bg-gray-100 dark:bg-gray-800">
            <th className="px-2 py-1 cursor-pointer text-gray-700 dark:text-gray-100" onClick={() => handleSort("date")}> 
              Date {sortConfig.key === "date" ? (sortConfig.direction === "asc" ? "\u25b2" : "\u25bc") : ""}
            </th>
            <th className="px-2 py-1 cursor-pointer text-gray-700 dark:text-gray-100" onClick={() => handleSort("description")}> 
              Description {sortConfig.key === "description" ? (sortConfig.direction === "asc" ? "\u25b2" : "\u25bc") : ""}
            </th>
            <th className="px-2 py-1 cursor-pointer text-gray-700 dark:text-gray-100" onClick={() => handleSort("credit")}> 
              Credit {sortConfig.key === "credit" ? (sortConfig.direction === "asc" ? "\u25b2" : "\u25bc") : ""}
            </th>
            <th className="px-2 py-1 cursor-pointer text-gray-700 dark:text-gray-100" onClick={() => handleSort("debit")}> 
              Debit {sortConfig.key === "debit" ? (sortConfig.direction === "asc" ? "\u25b2" : "\u25bc") : ""}
            </th>
            <th className="px-2 py-1 cursor-pointer text-gray-700 dark:text-gray-100" onClick={() => handleSort("category")}> 
              Category {sortConfig.key === "category" ? (sortConfig.direction === "asc" ? "\u25b2" : "\u25bc") : ""}
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredTransactions.map((tx, idx) => (
            <tr key={idx} className={idx % 2 === 0 ? "bg-gray-50 dark:bg-gray-800" : "bg-white dark:bg-gray-900"}>
              <td className="px-2 py-1 text-gray-700 dark:text-gray-100">{tx.date}</td>
              <td className="px-2 py-1 text-gray-700 dark:text-gray-100">{tx.description ?? tx.narration}</td>
              <td className="px-2 py-1 text-right text-gray-700 dark:text-gray-100">{tx.credit ?? ""}</td>
              <td className="px-2 py-1 text-right text-gray-700 dark:text-gray-100">{tx.debit ?? ""}</td>
              <td className="px-2 py-1 text-gray-700 dark:text-gray-100">{tx.category}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="flex items-center justify-between mt-2">
      <button
        disabled={page === 1}
        onClick={handlePrev}
        className="px-3 py-1 rounded bg-gray-200 mx-1 disabled:opacity-50"
      >
        Prev
      </button>
      <span>
        Page {page} of {Math.ceil(total / limit) || 1}
      </span>
      <button
        disabled={page * limit >= total}
        onClick={handleNext}
        className="px-3 py-1 rounded bg-gray-200 mx-1 disabled:opacity-50"
      >
        Next
      </button>
      <select
        value={limit}
        onChange={handleLimitChange}
        className="ml-4 border rounded px-2 py-1"
      >
        {[10, 20, 50, 100].map((l) => (
          <option key={l} value={l}>
            {l} / page
          </option>
        ))}
      </select>
    </div>
  </div>
);

export default TransactionsTable;